import { Component, signal } from '@angular/core';
import { TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../core/i18n';
import { ServiceGuaranteesDialog } from './service-guarantees-dialog/service-guarantees-dialog';

/**
 * Footnotes under the service matrix for guarantees and estimate disclaimers.
 * Only “Service Guarantees” opens the modal; Terms are linked inside that popup (OM-340 CR).
 */
@Component({
  selector: 'app-service-legalese',
  imports: [TranslatePipe, TypographyComponent, ServiceGuaranteesDialog],
  templateUrl: './service-legalese.html',
  styleUrl: './service-legalese.scss',
})
export class ServiceLegalese {
  protected readonly guaranteesDialogOpen = signal(false);

  /**
   * Opens the Service Guarantees information dialog.
   */
  protected openGuaranteesDialog(): void {
    this.guaranteesDialogOpen.set(true);
  }

  /**
   * Closes the Service Guarantees information dialog.
   */
  protected closeGuaranteesDialog(): void {
    this.guaranteesDialogOpen.set(false);
  }
}
